export function offline() { return typeof navigator !== 'undefined' && navigator.onLine === false; }
export function requireConnection() { if (offline()) throw {status: 0, code: 'OFFLINE'}; }
